import { useState } from 'react';

import { useAvailablePaymentMethods, usePromotePageState } from 'src/app/pages/promote/pageContext';
import { useTracking as usePromotePageTracking } from 'src/app/pages/promote/shared/hooks';
import type { SavedPaymentMethodContent } from 'src/app/pages/promote/shared/types';
import { useDeferredTrack } from 'src/app/shared/hooks/tracking';

import type { SavedPaymentMethodOption } from '../../../shared/types';

type Result = ModelHookResult<
	{
		savedPaymentMethods: SavedPaymentMethodContent[];
		selectedPaymentMethod: SavedPaymentMethodOption | null;
	},
	{
		onSelectPaymentMethod: (paymentMethod: string) => void;
	}
>;

export function useVariant1(): Result {
	const { savedPaymentMethods } = useAvailablePaymentMethods();
	const [, { setUsingSavedPaymentMethod, setPaymentType }] = usePromotePageState();

	const { trackPaymentSourceSelected } = usePromotePageTracking();
	const track = useDeferredTrack();

	const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<SavedPaymentMethodOption | null>(
		savedPaymentMethods.length > 0 ? savedPaymentMethods[0].type : null,
	);

	return {
		data: {
			savedPaymentMethods,
			selectedPaymentMethod,
		},
		actions: {
			onSelectPaymentMethod: (paymentMethod: string) => {
				const paymentMethodOption = paymentMethod as SavedPaymentMethodOption;
				setSelectedPaymentMethod(paymentMethodOption);
				if (paymentMethodOption !== 'new') {
					setUsingSavedPaymentMethod(true);
					setPaymentType(paymentMethodOption);
					trackPaymentSourceSelected(paymentMethodOption);
				} else {
					setUsingSavedPaymentMethod(false);
					track('pp_select_new_credit_card');
				}
			},
		},
	};
}
